import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import "../../../assets/styles/login-1.css";
import "../custom.css";

function AuthLayout({ children }) {
   const location = useLocation();
   const [step, setStep] = useState(1);

   useEffect(() => {
      if (location.pathname.includes("register-organization")) {
         setStep(2);
      } else if (location.pathname.includes("request-approval")) {
         setStep(3);
      } else if (location.pathname.includes("forgot-password")) {
         setStep(4);
      } else if (location.pathname.includes("password-confirm")) {
         setStep(5);
      } else {
         setStep(1);
      }
   }, [location]);

   return (
      <div className="d-flex flex-column flex-root login-layout">
         {/*begin::Login*/}
         <div
            className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
            id="kt_login"
         >
            {location.pathname === `/auth/login` ? (
               <div
                  className="login-aside d-flex bgi-size-cover bgi-no-repeat p-lg-10"
                  style={{
                     backgroundImage: `url(${toAbsoluteUrl("/media/bg/image-134.png")})`
                  }}
               >
                  <div className="d-flex flex-row-fluid flex-column align-items-center">
                     {/* start:: Aside header */}
                     <Link to="/" className="flex-column-auto mt-5 pt-20 pb-lg-0 pb-10">
                        <img
                           alt="Logo"
                           className="max-h-70px"
                           src={toAbsoluteUrl("/media/logos/svgg.svg")}
                        />
                     </Link>
                  </div>
               </div>
            ) : null}

            {/* <div className="d-flex flex-column flex-row-fluid position-relative p-7 layout-content"> */}

            <div className="d-flex flex-column flex-row-fluid position-relative layout-content">
               {/* <div className="d-flex flex-column-fluid flex-center mt-lg-0"> */}
               <div>
                  {" "}
                  {/* routes are here */}
                  <Outlet />
               </div>
            </div>
            {/*end::Content*/}
         </div>
         {/*end::Login*/}
      </div>
   );
}

export default AuthLayout;
